import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs';
import { ComponentWithDestroy } from 'src/app/modules/shared/component-with-destroy';
import { AuthService } from 'src/app/services/auth.service';
import { AUTH_USE_AUTH0 } from '../auth-use-auth0.injection-token';

@Component({
  selector: 'app-logout',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent extends ComponentWithDestroy implements OnInit {
  constructor(
    private authService: AuthService,
    private auth0Service: Auth0Service,
    private router: Router,
    private toaster: ToastrService,
    @Inject(AUTH_USE_AUTH0) private readonly useAuth0: boolean,
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.useAuth0) {
      this.authService
        .logout()
        .then(() => {
          this.router.navigate(['/login']);
        })
        .catch(error => {
          this.toaster.error(error);
        });
    } else {
      this.auth0Service
        .logout()
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.authService
            .logout()
            .then(() => {
              setTimeout(() => this.router.navigate(['/login']), 2000);
            })
            .catch(error => {
              this.toaster.error(error);
            });
        });
    }
  }
}
